import React from "react";
import { data } from "../data/data";
import ProjectList from "./projectList";
import Header from "../navigation/header";
import Footer from "../navigation/footer";
import { Link } from "react-router-dom";

export default function PythonProjects() {
    const pythonProjects = data.filter(proj => 
        proj.languages.includes('Python')
    );
    
    return (
        <>
            <Header />
            <div className="workMain">
                <div className="projects-page">
                    <div className="projects-header">
                        <Link to="/work" className="back-link">
                            <span className="back-arrow">←</span> Back to Work
                        </Link>
                        <h1 className="centered-title">Python Projects</h1>
                        <p className="projects-summary">
                            A selection of Python applications demonstrating problem-solving skills, 
                            algorithm implementation, and software development principles.
                        </p>
                    </div>
                    <ProjectList projects={pythonProjects} />
                </div>
            </div>
            <Footer />
        </>
    );
}